import { IAppState } from "../../types";
import { IQuestionnaryStateType } from "./questionnaire.type";

export const currentQuestionarySelector = ({
  questionnary,
}: IAppState): IQuestionnaryStateType => questionnary;
